import {LocationStrategy} from "@angular/common";
import {OnInit, AfterViewInit, Component, EventEmitter, Input, Output, Pipe, ViewChild} from "@angular/core";
import {AppService} from "@api";
import {FiltroModel} from "@componentes/Filtros/Filtro.model";
import {FiltrosComponent} from "@componentes/Filtros/Filtros.component";
import {TipoFiltroEnum} from "@componentes/Filtros/Filtros.enum";
import { MultiSelectComponent } from "@componentes/MultiSelect/MultiSelect.component";
import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {AlertaEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {Plantilla} from "@modelo/proceso/Plantilla.model";
import { FiltroArrayPipe } from "@pipes/FiltroArray.pipe";
import {SistemaService} from "@servicios/Sistema.Service";



@Component({
    selector: 'plantillapreguntaform',
    templateUrl: './plantillapreguntaForm.component.html',
    styleUrls: ['./plantillapregunta.component.scss']
})


export class PlantillaPreguntaFormComponent implements AfterViewInit {
    consulta!: boolean;
    entidad: Plantilla;
    @Input() accion!: {accionid: number, accion: string};
    @Input() entidadplantilla : Plantilla;
    @Input() parametro!: any;
    @Output() output = new EventEmitter();

    errornivel: boolean = false;
    cambio: boolean = false;
    public errorActivo!: boolean;
    ver: boolean = false;

    filtroevaluador: any[] = [];
    SelCompetencia: any[] = [];
    SelCriterio: any[] = [];
    SelTipoPregunta: any[] = [];
    SelTipoColaborador: any[] = [];
    SelDepartamento: any[] = [];
    SelDepartamentolista: any[] = [];
    SelGrados: any[] = [];
    SelGradoslista: any[] = [];
    SelPuestos: any[] = [];
    SelPuestoslista: any[] = [];
    selectedRows: any[] = [];
    SelEvaluador: any[] = [];
    SelNivel: any[] = [];
    SelNivellista: any[] = [];
    SelMateria: any[] = [];
    SelEscalaEvaluacion: any[] = [];
    SelEvaluadores: any[] = [];
    viewEvaluador: any[] = [];
    SelTipopregunta: any[] = [];
    listaPreguntaFiltro: any[] = [];
    preguntas: any[] = [];
    SelTipoplantilla: any[] = [];
    gradosvisibles: boolean = true;
    selectionChangedBySelectbox: boolean = false;

    verpuesto: boolean = false;
    verevaluador: boolean = false;
    verdepartamento: boolean = false;
    vernivel: boolean = false;
    vergrado: boolean = false;
    vermateria: boolean = false;
    veractivo: boolean = false;
    listamateriastring: string = "";


    dataTablePreguntas: any[] = [];
    dataTablePreguntasSeleccionadas: any[] = [];
    dataTablePreguntaPlantilla: any[] = [];

    nombrenivel: string = "";

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    @ViewChild("selectgrado") multiselectgrado!: MultiSelectComponent;
    @ViewChild("selectpuesto") multiselectpuesto!: MultiSelectComponent;
    @ViewChild("selectmateria") multiselectmateria!: MultiSelectComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string

    filtroindextipo!: number;
    constructor(private appService: AppService, private location: LocationStrategy, public sistemaService: SistemaService, private mensajeService: MensajeService) {
        this.uriApi = "planeacion/plantilla/buscarpregunta";
        this.entidad = new Plantilla();
        this.entidadplantilla = new Plantilla();

        this.GenerarFiltros();
    }

    ngAfterViewInit() {
        this.LoadDatos().then((respuesta : any)=>{
            //this.filtrosComponent.SetFiltros(this.filtrosDisplay, true);
            if(this.accion.accionid != 3){
                if(this.entidadplantilla.nivelid.length > 0){
                    this.filtrargrado(this.entidadplantilla.nivelid);
                }
                if(this.entidadplantilla.departamentoid && this.entidadplantilla.departamentoid.length > 0){
                    this.filtrarpuesto(this.entidadplantilla.departamentoid).then((res:any)=>{
                        if(res){
                            this.listamateriastring = this.entidadplantilla.materiacopiaselectid;
                            this.entidad = new Plantilla(this.entidadplantilla);
                        }else{
                            this.listamateriastring = this.entidadplantilla.materiacopiaselectid;
                            this.entidad = new Plantilla(this.entidadplantilla);
                        }
                        if(this.accion.accionid == 2){
                          this.asignarfiltro();
                        }
                    });
                }
                if(this.entidadplantilla.tipoplantillaid == 1){
                    this.viewEvaluador = this.SelEvaluador.filter(x=>x.evaluadorid == 1);
                }else{
                    this.viewEvaluador = this.SelEvaluador.filter(x=>x.evaluadorid != 1);
                }
                if(this.entidadplantilla.evaluadorid){
                    this.selectevaluador(this.entidadplantilla.evaluadorid);
                }
                if(this.entidadplantilla.nivelid.length > 0  && this.entidadplantilla.gradoid.length > 0){
                    this.SetMateriaediar().then((res:any)=>{
                        if(res){
                            this.listamateriastring = this.entidadplantilla.materiacopiaselectid;
                            this.entidad = new Plantilla(this.entidadplantilla);
                        }else{
                            this.listamateriastring = this.entidadplantilla.materiacopiaselectid;
                            this.entidad = new Plantilla(this.entidadplantilla);
                        }
                        if(this.accion.accionid == 2){
                          this.asignarfiltro();
                        }
                    })
                }
            }
       });
        if (this.accion.accionid == 1) {
            this.ver = true;
            this.veractivo = true;
            this.validardatosiniciales(this.entidadplantilla.tipoplantillaid);
            this.SetPlantillaPorPregunta()
        }else if(this.accion.accionid == 2){
            this.SetPlantillaPorPregunta()
            this.veractivo = true;
            this.validardatosiniciales(this.entidadplantilla.tipoplantillaid);
        }
        if (this.entidadplantilla.materiacopiaid != null) {
            this.entidadplantilla.materiaid = [];
            for (let valoremateria of this.entidadplantilla.materiacopiaid.split(", ")) {
                this.entidadplantilla.materiaid.push(parseInt(valoremateria))
            }
        }
        if (this.entidadplantilla.gradocopiarid != null) {
            this.entidadplantilla.gradoid = [];
            for (let valorgradoid of this.entidadplantilla.gradocopiarid.split(", ")) {
                this.entidadplantilla.gradoid.push(parseInt(valorgradoid))
            }
        }
        if (this.entidadplantilla.puestocopiarid != null) {
            this.entidadplantilla.puestoid = [];
            for (let valorpuestoid of this.entidadplantilla.puestocopiarid.split(", ")) {
                this.entidadplantilla.puestoid.push(parseInt(valorpuestoid))
            }
        }

    }

    //Generacion del filtro de preguntas
    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Clave',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'clave',
                    Hidden: true,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Competencia',
                    DisplayValor: 'nombre',
                    ValorName: 'competenciaid',
                    Opciones: this.SelCompetencia,
                    Propiedad: "competenciaid",
                    Obligatorio: false,
                    Buscar: true,
                    Suscripcion: new EventEmitter(),
                    Hidden: true,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Criterio',
                    DisplayValor: 'nombre',
                    ValorName: 'criterioid',
                    Opciones: this.SelCriterio,
                    Propiedad: "criterioid",
                    Obligatorio: false,
                    Buscar: false,
                    Hidden: true,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'pregunta',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'pregunta',
                    Hidden: true,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDownMulti,
                    Valor: [],
                    Titulo: 'Nivel',
                    DisplayValor: 'nombre',
                    ValorName: 'nivelid',
                    Opciones: this.SelNivel,
                    Propiedad: "nivelid",
                    Obligatorio: true,
                    Buscar: false,
                    Hidden: true,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Tipo pregunta',
                    DisplayValor: 'nombre',
                    ValorName: 'tipopreguntaid',
                    Opciones: this.SelTipopregunta,
                    Propiedad: "tipopreguntaid",
                    Obligatorio: true,
                    Buscar: false,
                    Suscripcion: new EventEmitter()
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Escala evaluación',
                    DisplayValor: 'nombre',
                    ValorName: 'escalaevaluacionid',
                    Opciones: this.SelEscalaEvaluacion,
                    Propiedad: "escalaevaluacionid",
                    Obligatorio: true,
                    Buscar: false
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Valor: true,
                    Titulo: 'Activo',
                    DisplayValor: 'nombre',
                    ValorName: 'valor',
                    Opciones: [{nombre: "Sí", valor: true}, {nombre: "No", valor: false}],
                    Propiedad: "activo",
                    Obligatorio: true,
                    disabled: true,
                    Buscar: false
                })
        );

        this.filtrosDisplay = filtrosDisplay;
        this.filtroindextipo =  this.filtrosDisplay.findIndex(x => x.ValorName == 'tipopreguntaid')
    }

    LoadDatos(){
        return new Promise((resolve) =>{
            Promise.all([
            this.SetDepartamentoFiltro(),
            this.SetNivelFiltro(),
            this.SetCompetenciaFiltro(),
            this.SetGrado(),
            this.SetPuesto(),
            this.SetEvaluadorPlantilla(),
            this.SetTipoPreguntaFiltro(),
            this.SetTipoPlantilla()
          ]).then((responses : any) =>{
            return resolve(responses);
          });
        });
      }

    //Trae las nivel para el filtro de las plantilla
    SetNivelFiltro() {
        return new Promise ((resolve) =>{
        this.appService.Get("catalogo/nivel").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelNivel = res.data;
                if(this.filtrosComponent){
                    let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'nivelid');
                    if (filtro) {
                        filtro.Opciones = this.SelNivel;
                        return resolve(true);
                    }else{
                        return resolve(false);
                    }
                }else{
                    return resolve(true);
                }

            }else{
                return resolve(false);
            }
        });
        });
    }

    //Trae las departamento para el filtro de las plantilla
    SetDepartamentoFiltro() {
        return new Promise ((resolve) =>{
        this.appService.Post("configuracionrh/departamento/buscar", {activo: 1}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelDepartamento = res.data;
                this.SelDepartamentolista = res.data;
                return resolve(true);
            }else{
                return resolve(false);
            }
        });
    });
    }

    //Trae las competencia para el filtro de las plantilla
    SetCompetenciaFiltro() {
        return new Promise((resolve : any) =>{
        this.appService.Post("configuracion/competencia/buscar", {activo: 1}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelCompetencia = res.data;
                if(this.filtrosComponent){
                    let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'competenciaid');
                    if (filtro) {
                        filtro.Opciones = this.SelCompetencia;
                        filtro.Suscripcion.subscribe((v: number) => {
                            this.SetCriterio(v);
                        });
                        return resolve(true);
                    }
                    else{
                        return resolve(false);
                    }
                }else{
                    return resolve(true);
                }
            }
            else{
                return resolve(false);
            }
        });
    });
    }

    //Traer los criterios dependiendo de la competenecia seleccionada para el filtro de preguntas
    SetCriterio(competenciaid: number) {
        let filtro = this.filtrosComponent.filtrosSeleccionados.find(x => x.ValorName == 'criterioid');
        if (filtro) {
            filtro.Valor = null;
            if (!competenciaid) {
                this.SelCriterio = [];
                filtro.Opciones = this.SelCriterio;
                return;
            }

            this.appService.Post("configuracion/criterio/buscar", {competenciaid: competenciaid, activo: 1}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.SelCriterio = res.data;
                    if (filtro) {
                        filtro.Opciones = this.SelCriterio;
                    }
                }
            });
        }
    }

    //Traer los grados que se utilizan para el dropbox
    SetGrado() {
        return new Promise ((resolve) =>{
            this.appService.Get("catalogo/grado").then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.SelGrados = res.data;
                    this.gradosvisibles = true;
                    return resolve(true);
                }else{
                    return resolve(false);
                }
            });
        });
    }

    selectevaluador(e:number, limpiar: number = 0){
        if(limpiar != 0){
            this.entidad.nivelid = [];
            this.entidad.departamentoid = [];
            this.entidad.puestoid = [];
            this.entidad.gradoid = [];
            this.entidad.materiaid = [];
            this.SelGradoslista = [];
            this.SelNivellista = [];
            let filtroindex = this.filtrosDisplay.findIndex(x => x.ValorName == 'nivelid');
            let filtroindextipo = this.filtrosDisplay.findIndex(x => x.ValorName == 'tipopreguntaid');
            let filtroindexescala = this.filtrosDisplay.findIndex(x => x.ValorName == 'escalaevaluacionid');
            this.filtrosDisplay[filtroindextipo].Valor = null;
            this.filtrosDisplay[filtroindexescala].Valor = null;
            this.filtrosDisplay[filtroindex].Valor = [];
            this.filtrosComponent.SetFiltros(this.filtrosDisplay, false);
            if(this.multiselectgrado){
                this.multiselectgrado.LimpiarSelect();
            }
            if(this.multiselectpuesto){
                this.multiselectpuesto.LimpiarSelect();
            }
            if(this.multiselectmateria){
              if(this.multiselectmateria.datoSeleccionado.length > 0){
                this.multiselectmateria.LimpiarSelect();
              }
            }
        }
        if(e){
            switch(e){
                case 1:
                  let filtroindextipo = this.filtrosDisplay.findIndex(x => x.ValorName == 'tipopreguntaid');
                  let filtroindexescala = this.filtrosDisplay.findIndex(x => x.ValorName == 'escalaevaluacionid');
                  this.filtrosDisplay[filtroindextipo].Valor = 1;
                  this.SetEscalaEvaluacionFiltro(1).then(x=>{
                    this.filtrosDisplay[filtroindexescala].Valor = 1
                    this.filtrosComponent.SetFiltros(this.filtrosDisplay, false);});
                    this.SelNivellista = this.SelNivel;
                  break;
                case 2:
                    this.SelNivellista = this.SelNivel;
                    break;
                case 3:
                    let nivelidsuperior = [2,3, 4]
                    this.SelNivellista = new FiltroArrayPipe().transform(this.SelNivel, nivelidsuperior, "nivelid");
                    break;
                case 4:
                    let nivelidinferior = [1, 2]
                    this.SelNivellista = new FiltroArrayPipe().transform(this.SelNivel, nivelidinferior, "nivelid");
                    break;
            }
        }
    }

    filtrargrado(nivelid: any[]){
        let filtroindex = this.filtrosDisplay.findIndex(x => x.ValorName == 'nivelid');

        if(nivelid.length > 0){
            if(filtroindex && this.filtrosComponent){
                this.filtrosDisplay[filtroindex].Valor = nivelid;
                this.filtrosComponent.SetFiltros(this.filtrosDisplay, false);
            }
            let primaria = nivelid.find(x=>x==2);
            if(primaria){
                let superior = nivelid.find(x=>x==3 || x == 4);
                let inferior = nivelid.find(x=>x == 1);
                if(superior && inferior){
                    if((this.entidadplantilla.evaluadorid == 2 || this.entidad.evaluadorid  == 2) || (this.entidadplantilla.evaluadorid == 1 || this.entidad.evaluadorid == 1)){
                        this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                    }else{
                        this.mensajeService.Alerta(AlertaEnum.Warning, "No puedes combinar preescolar con secundaria o bachillerato")
                        this.SelGradoslista = [];
                        this.entidad.gradoid = [];
                    }
                }
                else if(superior){
                    if((this.entidadplantilla.evaluadorid == 2 || this.entidad.evaluadorid == 2)){
                        this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                    }else{
                        let listagradoquitarsuperior  = [{"gradoid":4}, {"gradoid":5}, {"gradoid": 6}];
                        this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                        for(let grado of listagradoquitarsuperior){
                           this.SelGradoslista = this.SelGradoslista.filter(x=>x.gradoid != grado.gradoid);
                        }
                    }

                }else if(inferior){
                    if((this.entidadplantilla.evaluadorid == 2 || this.entidad.evaluadorid == 2)){
                        this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                    }else{
                        let listagradoquitarinferior = [{"gradoid":7}, {"gradoid":8}, {"gradoid": 9}];
                        this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                        for(let grado of listagradoquitarinferior){
                            this.SelGradoslista = this.SelGradoslista.filter(x=>x.gradoid != grado.gradoid);
                         }
                    }

                }else{
                  if(this.entidad.evaluadorid  == 3){
                    let listagradoquitarsuperior  = [{"gradoid":4}, {"gradoid":5}, {"gradoid": 6}];
                    this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                    for(let grado of listagradoquitarsuperior){
                       this.SelGradoslista = this.SelGradoslista.filter(x=>x.gradoid != grado.gradoid);
                    }
                  }else if(this.entidad.evaluadorid == 4){
                    let listagradoquitarinferior = [{"gradoid":7}, {"gradoid":8}, {"gradoid": 9}];
                    this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                    for(let grado of listagradoquitarinferior){
                      this.SelGradoslista = this.SelGradoslista.filter(x=>x.gradoid != grado.gradoid);
                    }
                  }else if(this.entidadplantilla.evaluadorid == 3){
                    let listagradoquitarsuperior  = [{"gradoid":4}, {"gradoid":5}, {"gradoid": 6}];
                    this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                    for(let grado of listagradoquitarsuperior){
                       this.SelGradoslista = this.SelGradoslista.filter(x=>x.gradoid != grado.gradoid);
                    }
                  }else if (this.entidadplantilla.evaluadorid == 4) {
                    let listagradoquitarinferior = [{"gradoid":7}, {"gradoid":8}, {"gradoid": 9}];
                    this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                    for(let grado of listagradoquitarinferior){
                      this.SelGradoslista = this.SelGradoslista.filter(x=>x.gradoid != grado.gradoid);
                    }
                  }
                  else{
                    this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                  }
                }
            }else{
                let preescolar = nivelid.find(x=>x==1);
                if(preescolar){
                    let superior = nivelid.find(x=>x==3 || x == 4);
                    if(superior){
                        if((this.entidadplantilla.evaluadorid == 2 || this.entidad.evaluadorid == 2) || (this.entidadplantilla.evaluadorid== 1 || this.entidad.evaluadorid == 1)){
                            this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                        }else{
                            this.mensajeService.Alerta(AlertaEnum.Warning, "No puedes combinar preescolar con secundaria o bachillerato")
                            this.SelGradoslista = [];
                            this.entidad.gradoid = [];
                        }
                    }else{
                        this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                    }
                }else{
                    this.SelGradoslista = new FiltroArrayPipe().transform(this.SelGrados, nivelid, "nivelid");
                }
            }
            if(this.accion.accionid != 1){
                this.entidad.departamentoid = [];
                this.entidad.puestoid = [];
                this.SelPuestoslista = [];
                if(this.multiselectpuesto){
                    this.multiselectpuesto.LimpiarSelect();
                }
                if(this.multiselectgrado){
                  this.multiselectgrado.LimpiarSelect();
                }
                this.entidad.materiaid = [];
                if(this.multiselectmateria){
                  if(this.multiselectmateria.datoSeleccionado.length > 0){
                    this.multiselectmateria.LimpiarSelect();
                  }
                }
            }
        }else{
            this.SelGradoslista = [];
            this.entidad.gradoid = [];
            this.entidad.materiaid = [];
            if(this.multiselectmateria){
              if(this.multiselectmateria.datoSeleccionado.length > 0){
                this.multiselectmateria.LimpiarSelect();
              }
            }
            if(this.multiselectgrado){
                this.multiselectgrado.LimpiarSelect();
            }
            if(this.filtrosComponent){
                this.filtrosDisplay[filtroindex].Valor = [];
                this.filtrosComponent.SetFiltros(this.filtrosDisplay, false);
            }
        }
    }

    SetPuesto(){
        return new Promise ((resolve) =>{
            this.appService.Post("configuracionrh/puesto/buscar", {activo: 1}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                    this.SelPuestos = res.data;
                    return resolve(true);
                }else{
                    return resolve(false);
                }
            })
        })

    }

    filtrarpuesto(departamentoid: any[]){
        return new Promise ((resolve) =>{
        if(departamentoid.length > 0){
            this.SelPuestoslista = new FiltroArrayPipe().transform(this.SelPuestos, departamentoid, "departamentoid");
            this.SelPuestoslista = this.SelPuestoslista.sort((a:any,b:any)=> (a.nombre < b.nombre ? -1:1))
            return resolve(true);
        }else{
            this.SelPuestoslista = [];
            return resolve(false);
        }
    });
    }

    SetTipoPlantilla(){
        return new Promise ((resolve) =>{
        this.appService.Post("planeacion/plantilla/tipoplantilla",{}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.SelTipoplantilla = res.data;
                return resolve(true);
            }else{
                return resolve(false);
            }
        })
    });
    }

    SetEvaluadorPlantilla() {
        return new Promise ((resolve) =>{
        this.appService.Get("catalogo/evaluador").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelEvaluador = res.data;
                return resolve(true);
            }else{
                return resolve(false);
            }
        });
        });
    }

    SetTipoPreguntaFiltro(){
        return new Promise ((resolve) =>{
        this.appService.Get("catalogo/tipopregunta").then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.SelTipopregunta = res.data;
                let filtro = this.filtrosDisplay.find(x => x.ValorName == 'tipopreguntaid');
                if (filtro) {
                    filtro.Opciones = this.SelTipopregunta;
                    filtro.Suscripcion.subscribe((v: number) => {
                        this.SetEscalaEvaluacionFiltro(v).then((respuesta : any) =>
                        {
                        });
                    })
                    return resolve(true);
                }else{
                    return resolve(false);
                }
            }else{
                return resolve(false);
            }
        })
    });
    }

    SetEscalaEvaluacionFiltro(valor:number){
        return new Promise ((resolve) =>{
        if(valor == 1){
            let filtro = this.filtrosDisplay.find(x => x.ValorName == 'escalaevaluacionid');
            let filtroindex = this.filtrosDisplay.findIndex(x => x.ValorName == 'escalaevaluacionid');
        if (filtro) {
            filtro.Valor = null;
            if (!valor) {
                this.SelEscalaEvaluacion = [];
                filtro.Opciones = this.SelEscalaEvaluacion;
                return resolve(false);
            }

            this.appService.Post("configuracion/escalaevaluacion/buscar",{activo: 1}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                    this.SelEscalaEvaluacion = res.data;
                    if (filtro) {
                        if(this.filtrosComponent.filtrosSeleccionados.length > 0){
                            this.filtrosComponent.filtrosSeleccionados[filtroindex].Opciones = this.SelEscalaEvaluacion;
                        }else{
                            filtro.Opciones = this.SelEscalaEvaluacion;
                        }
                    }
                    return resolve(true);
                }else{
                    return resolve(false);
                }
            })
        }else{
            return resolve(false);
        }
        }else{
        let filtro = this.filtrosComponent.filtrosSeleccionados.find(x => x.ValorName == 'escalaevaluacionid');
        if (filtro) {
            filtro.Valor = null;
            this.SelEscalaEvaluacion = [];
            filtro.Opciones = this.SelEscalaEvaluacion;
        }
        return resolve(false);
        }
    });
    }

    SetPlantillaPorPregunta() {
        return new Promise ((resolve) =>{
        this.appService.Post("planeacion/plantilla/plantillaporpregunta", {plantillaid: this.entidadplantilla.plantillaid}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.dataTablePreguntaPlantilla = res.data;
                return resolve(true);
            }else{
                return resolve(false);
            }
        });
        });
    }

    SetMateriaediar(){
        return new Promise ((resolve) =>{
        if(this.entidadplantilla.nivelid.length > 0 && this.entidadplantilla.gradoid.length > 0){
            this.appService.Post("planeacion/plantilla/materiaorganigrama",{"nivel":this.entidadplantilla.nivelid, "grado": this.entidadplantilla.gradoid}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                    this.SelMateria = res.data;
                    return resolve(true);
                }else{
                    return resolve(false);
                }
            })
        }else{
            this.mensajeService.Alerta(AlertaEnum.Warning, "Se requiere seleccionar mínimo un nivel y un grado para realizar la búsqueda de materias")
            return resolve(false);
        }
    });
    }

    SetMateria(){
        if(this.entidad.nivelid.length > 0 && this.entidad.gradoid.length > 0){
            this.appService.Post("planeacion/plantilla/materiaorganigrama",{"nivel":this.entidad.nivelid, "grado": this.entidad.gradoid}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                    this.SelMateria = res.data;
                }
            })
        }else{
            this.mensajeService.Alerta(AlertaEnum.Warning, "Se requiere seleccionar mínimo un nivel y un grado para realizar la búsqueda de materias")
        }
    }

    limpiarmaterias(listgrado: any[]){
        if(listgrado.length > 0){
          if(this.entidad.gradoid.length == 1){
            this.asignarfiltro();
          }
          if(this.multiselectgrado.seleccionadosTodos){
            this.asignarfiltro();
          }
        }else{
          this.SelMateria = [];
          let filtroindextipo = this.filtrosDisplay.findIndex(x => x.ValorName == 'tipopreguntaid');
          let filtroindexescala = this.filtrosDisplay.findIndex(x => x.ValorName == 'escalaevaluacionid');
          this.filtrosDisplay[filtroindextipo].Valor = null;
          this.filtrosDisplay[filtroindexescala].Valor = null;
          this.filtrosComponent.SetFiltros(this.filtrosDisplay, false);
        }
    }

    //pasa la informacion a las tablas correspondientes
    SetDatos(data: any) {
        this.dataTablePreguntas = data;
        console.log(this.dataTablePreguntas);
        for (let preguntaplantilla of this.dataTablePreguntaPlantilla) {
            this.dataTablePreguntas.forEach((element, index) => {
                if (preguntaplantilla.preguntaid == element.preguntaid) {
                    this.dataTablePreguntas.splice(index, 1)
                }
            })
        }
    }

    //Agrega la relacion de las preguntas seleccionadas a la plantilla
    AgregarPreguntasPlantillas() {
        if (this.selectedRows.length > 0) {
            for (let preguntaid of this.selectedRows) {
                this.dataTablePreguntas.forEach((element, index) => {
                    if (element.preguntaid == preguntaid) {
                        element["obligatorio"] = false;
                        this.dataTablePreguntaPlantilla.push(element)
                        this.dataTablePreguntas.splice(index, 1)
                    }
                })
            }
        } else {
            this.mensajeService.Alerta(AlertaEnum.Warning, "Se tiene que seleccionar mínimo una pregunta para realizar esta acción")
        }
    }

    //Elimina la relacion entre las preguntas seleccionadas con la plantilla
    QuitarPreguntasPlantillas() {
        if (this.dataTablePreguntasSeleccionadas.length > 0) {
            for (let preguntaid of this.dataTablePreguntasSeleccionadas) {
                this.dataTablePreguntaPlantilla.forEach((element, index) => {
                    if (element.preguntaid == preguntaid) {
                        this.dataTablePreguntas.push(element)
                        this.dataTablePreguntaPlantilla.splice(index, 1)
                    }
                })
            }
            this.dataTablePreguntas.sort((a: any, b: any) => a.clave - b.clave);
        } else {
            this.mensajeService.Alerta(AlertaEnum.Warning, "Se tiene que seleccionar mínimo una pregunta para realizar esta acción")
        }

    }

    cargarinfo(tipoplantillaid : number){
        this.verevaluador = false;
        let filtroindex = this.filtrosDisplay.findIndex(x => x.ValorName == 'nivelid');
        let filtroindextipo = this.filtrosDisplay.findIndex(x => x.ValorName == 'tipopreguntaid');
        let filtroindexescala = this.filtrosDisplay.findIndex(x => x.ValorName == 'escalaevaluacionid');
        this.filtrosDisplay[filtroindextipo].Valor = null;
        this.filtrosDisplay[filtroindexescala].Valor = null;
        this.filtrosDisplay[filtroindex].Valor = [];
        this.filtrosComponent.SetFiltros(this.filtrosDisplay, false);
        this.viewEvaluador = [];
        this.entidad.evaluadorid = 0;
        this.entidad.departamentoid = [];
        this.entidad.puestoid = [];
        this.entidad.materiaid = [];
        this.entidad.gradoid = [];
        this.entidad.nivelid = [];
        this.SelNivellista = [];
        this.vernivel = false;
        this.verdepartamento = false;
        this.verpuesto = false;
        this.vermateria = false;
        this.vergrado = false;
        this.errornivel = false;
        this.veractivo = false;
        this.validardatosiniciales(tipoplantillaid)
        if(tipoplantillaid == 1){
            this.viewEvaluador = this.SelEvaluador.filter(x=>x.evaluadorid == 1);
            if(!this.entidadplantilla.evaluadorid){
              this.entidad.evaluadorid = this.viewEvaluador[0].evaluadorid;
              this.selectevaluador(this.entidad.evaluadorid);
            }else if(!this.entidad.evaluadorid){
              this.entidad.evaluadorid = this.viewEvaluador[0].evaluadorid;
              this.selectevaluador(this.entidad.evaluadorid);
            }
        }else{
            this.viewEvaluador = this.SelEvaluador.filter(x=>x.evaluadorid != 1);
        }
    }

    //Valida que el formulario este completo
    Validar(): any {
        this.errorActivo = true;
        if (!this.entidad.tipoplantillaid) {
            return "Se requiere seleccionar el tipo de plantilla"
        }
        if (!this.entidad.descripcion) {
            return "Se tiene que escribir la descripción de la plantilla"
        }
        if (!this.entidad.evaluadorid) {
            return "Se requiere seleccionar mínimo un evaluador"
        }
        switch(this.entidad.tipoplantillaid){
            case 1:
                if (!this.entidad.departamentoid) {
                    return "Se requiere seleccionar un departamento"
                }
                break;
            case 2:
                if(this.entidad.nivelid.length == 0){
                    this.errornivel = true;
                    return "Se requiere seleccionar un nivel"
                }
                if (this.entidad.gradoid.length == 0) {
                    return "Se requiere seleccionar mínimo un grado"
                }
                if (this.entidad.materiaid.length == 0) {
                    return "Se requiere seleccionar mínimo una materia para este tipo de plantilla"
                }
                break;
            case 3:
                if (!this.entidad.departamentoid) {
                    return "Se requiere seleccionar un departamento"
                }
                if(this.entidad.nivelid.length == 0){
                    this.errornivel = true;
                    return "Se requiere seleccionar un nivel"
                }
                if (this.entidad.gradoid.length == 0) {
                    return "Se requiere seleccionar mínimo un grado"
                }
                break;
            case 4:
                if(this.entidad.nivelid.length == 0){
                    this.errornivel = true;
                    return "Se requiere seleccionar un nivel"
                }
                if (this.entidad.gradoid.length == 0) {
                    return "Se requiere seleccionar mínimo un grado"
                }
                break;
        }
        if (this.dataTablePreguntaPlantilla.length == 0) {
            return "Se tiene que asignar mínimo una preguta a la plantilla"
        }
        return true
    }

    //Guarda la plantilla
    Guardar() {
        let respuesta = this.Validar();
        let data = new Plantilla(this.entidad)
        if (respuesta == true) {
            this.appService.Post("planeacion/plantilla", {"plantilla":data, "listapregunta": this.dataTablePreguntaPlantilla}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                    this.cambio = true
                    this.Salir();
                }
            });
        } else {
            this.mensajeService.Alerta(AlertaEnum.Warning, respuesta)
        }
    }

    //Salir del formulario
    Salir() {
        this.output.next(this.cambio);
    }

    validardatosiniciales(data:any){
        switch(data){
            case 1:
                this.verevaluador = true;
                this.vernivel = true;
                this.verdepartamento = true;
                this.verpuesto = true;
                this.vermateria = false;
                this.vergrado = false;
                this.veractivo = true;
                this.nombrenivel = "Nivel(s)";
                break;
            case 3:
                this.verevaluador = true;
                this.vernivel = true;
                this.verdepartamento = true;
                this.verpuesto = true;
                this.vermateria = false;
                this.vergrado = true;
                this.veractivo = true;
                this.errornivel = true;
                this.nombrenivel = "Nivel(s)*";
                break;
            case 2:
                this.verevaluador = true;
                this.vernivel = true;
                this.verdepartamento = false;
                this.verpuesto = false;
                this.vermateria = true;
                this.vergrado = true;
                this.veractivo = true;
                this.errornivel = true;
                this.nombrenivel = "Nivel(s)*";
                break;
            case 4:
                this.verevaluador = true;
                this.vernivel = true;
                this.verdepartamento = false;
                this.verpuesto = false;
                this.vermateria = false;
                this.vergrado = true;
                this.veractivo = true;
                this.errornivel = true;
                this.nombrenivel = "Nivel(s)*";
                break;
        }
    }

    Consultar(){
        this.filtrosComponent.Consultar(this.filtrosDisplay);
    }

    filtroporboleando(e:any){
       return e.mostrarautoevaluacion
    }

    asignarfiltro(){
      let filtroindextipo = this.filtrosDisplay.findIndex(x => x.ValorName == 'tipopreguntaid');
      let filtroindexescala = this.filtrosDisplay.findIndex(x => x.ValorName == 'escalaevaluacionid');
      switch(this.entidad.evaluadorid){
        case 2:
        case 3:

            this.filtrosDisplay[filtroindextipo].Valor = 1;
            this.SetEscalaEvaluacionFiltro(1).then(x=>{
            this.filtrosDisplay[filtroindexescala].Valor = 1
            this.filtrosComponent.SetFiltros(this.filtrosDisplay, false);});

          break;
        case 4:
            if(filtroindextipo){
              this.filtrosDisplay[filtroindextipo].Valor = 1;
              this.SetEscalaEvaluacionFiltro(1).then(x=>{
                this.filtrosDisplay[filtroindexescala].Valor = 2
                this.filtrosComponent.SetFiltros(this.filtrosDisplay, false);});
          }
          break;
      }
    }
}
